import { Component, OnInit,Inject,HostListener } from '@angular/core';
import { DashboardService } from '../services/dashboard.service';
import { OfflinepaymentComponent } from './offlinepayment/offlinepayment.component';

declare var Razorpay: any;
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import {
  MatPaginator,
  MatSort,
  MatTableDataSource,
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material";
@Component({
  selector: 'app-renewal-window',
  templateUrl: './renewal-window.component.html',
  styleUrls: ['./renewal-window.component.scss']
})
export class RenewalWindowComponent implements OnInit {
  rzp: any;
  message;
  payableAmout;
  totalPayable; 
  selectedYears: number = 1; 
  constructor(@Inject(MAT_DIALOG_DATA) public data,private _dashboardService: DashboardService,private dialog: MatDialog) { }

  ngOnInit() {
    
     this.payableAmout = this.data.amount
    .filter(item => item.amc_status === "Expired")
    .reduce((total, item) => total + Number(item.amount || 0), 0);
  this.totalPayable = this.payableAmout * this.selectedYears;
  }
    onYearChange() {
    this.totalPayable = this.payableAmout * this.selectedYears;
  }
  getrenewalDate(){
          this.paynow(this.data.data)
  }
  paynow(data) {
    console.log("checking this.data",this.data)
    let options = {
      "key": "rzp_live_dhkbrwfan9oVLv", // Enter the Key ID generated from the Dashboard
      "amount": this.totalPayable*100, // Amount is in currency subunits. Default currency is INR. Hence, 100 refers to 1 rs
      "currency": "INR",
      "name": "Kryfs Technologies Pvt Ltd", //your business name
     "description": `${this.selectedYears} Year Subscription`,
      "image": "https://kryfs.com/wp-content/uploads/2023/06/Asset-10KRYFS-Logos.png",
      "prefill": { 
        "name": data[0].first_name+' '+data[0].last_name, 
        "email": data[0].email,
        "contact": data[0].mobile_number
    },
      "notes": {
          "address": "Razorpay Corporate Office"
      },
      "theme": {
          "color": "#cf2d2d"
      },
      "handler":(response) =>  {
        console.log(response)
        const devices = this.data.amount.map((item: any) => ({
  device_id: item.deviceId,
  transformer_id: item.transformerid,
  amc_period: this.selectedYears   // same duration for all
}));

console.log("📤 Sending devices:", devices);
        this._dashboardService.updateUserRenewalDate({devices}).subscribe((response2: any) => {
          if(response2.code == 1){
            window.location.reload();
            this._dashboardService.getRenewalInvoice(this.data.data[0]).subscribe((response1: any) => {
              console.log("ksjfjksdbsdfjsd",response1)
                let downloadURL = window.URL.createObjectURL(response1);
                saveAs(downloadURL,'KTECHIN'+data[0].id);              
                });
            }
        });        
      },
      "onpaymenterror": (error) => {
        // Handle failure response here
        console.error("Payment failed!", error);
        // Your failure logic here
        alert("Payment failed. Please try again.");

        // Optionally, you can redirect or perform any other action on failure
        // window.location.href = "/payment-failure-page";
    }

  };

    this.rzp = new Razorpay(options);
    this.rzp.open();
  }
  @HostListener('window:payment.success', ['$event'])
  onPaymentSuccess(event: any): void {

  }
  getFilenameFromContentDisposition(contentDisposition: string): string {
  const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
  if (matches != null && matches[1]) {
    return matches[1].replace(/['"]/g, '');
  }
  return 'renewal_invoice.pdf'; // Default filename if extraction fails
}
offlinepayment(){

  let dialogRef = this.dialog.open(OfflinepaymentComponent,{ 
    autoFocus: false,
              height: '90%', width: '60%', data: this.data.data, panelClass: 'custom-dialog-container'
  });
  dialogRef.afterClosed().subscribe((response) => {
  })
}
}
